import Redirect from './Redirect';
import { useAuth } from '@presov.sk/presov-auth-react';
import React from 'react';
import { Outlet } from 'react-router';

const PrivatePages: React.FC = () => {
  const { authState } = useAuth();

  if (authState === 'authorizing') {
    return null;
  }

  if (authState === 'unauthorized') {
    return <Redirect to='/' />;
  }

  return <Outlet />;
};

export default PrivatePages;
